export default __webpack_public_path__ + "static/media/img4.a3f75e1f.svg";